import React, { Component } from 'react';
import { func, array, number } from 'prop-types';
import { translate, Interpolate } from 'react-i18next';

import { camelcaseParser } from '@snapask/common-components/dist/utils/objCamelcaseParser';
import { ChevronRightIcon } from '@snapask/common-components';

import { yearMonthDayFormat } from '@dragonfruit/utils/dateParser';
import { quotaParser } from '@dragonfruit/utils/quotaParser';

import { QA } from '@dragonfruit/constants/productType';

import styles from './AccountHistoricalPurchases.scss';

class AccountHistoricalPurchases extends Component {
  static propTypes = {
    currentPage: number.isRequired,
    purchases: array.isRequired,
    purchasesPerPage: number.isRequired,
    t: func.isRequired,
    onClickPurchase: func.isRequired,
  };

  renderBillingHistoryRows = ({
    name,
    startAt,
    status: paymentStatus,
    displaySellPrice,
    id,
    isUnlimited,
    questionQuota,
    productType,
  }) => {
    const { t, onClickPurchase } = this.props;

    return (
      <tr key={id}>
        <td>{yearMonthDayFormat(startAt)}</td>
        <td>
          <p>{name}</p>
          {productType === QA && (
            <p className={styles.small}>
              <Interpolate
                i18nKey="account.questionWithoutDate"
                questionQuota={quotaParser(questionQuota, isUnlimited)}
              />
            </p>
          )}
        </td>
        <td>{displaySellPrice}</td>
        <td>
          <div className={styles.openDetail} onClick={onClickPurchase(id)}>
            <p>
              {t(`account.billingStatus.${camelcaseParser(paymentStatus)}`)}
            </p>
            <ChevronRightIcon width={24} height={24} />
          </div>
        </td>
      </tr>
    );
  };

  renderPurchasedItem = ({
    name,
    paymentType,
    startAt,
    status: paymentStatus,
    displaySellPrice,
    id,
  }) => {
    const { t, onClickPurchase } = this.props;

    return (
      <li key={id}>
        <div className={styles.listDate}>
          <div className={styles.row}>
            <h4>{t('account.date')}</h4>
            <p>{yearMonthDayFormat(startAt)}</p>
          </div>
          <div className={styles.row}>
            <h4>{t('account.type')}</h4>
            <div className={styles.packageDetails}>
              <p className={styles.name}>{name}</p>
              <p>{paymentType}</p>
            </div>
          </div>
          <div className={styles.row}>
            <h4>{t('account.amount')}</h4>
            <p>{displaySellPrice}</p>
          </div>
          <div className={styles.row}>
            <h4>{t('account.status')}</h4>
            <div className={styles.openDetail} onClick={onClickPurchase(id)}>
              <p>
                {t(`account.billingStatus.${camelcaseParser(paymentStatus)}`)}
              </p>
              <ChevronRightIcon width={12} height={12} />
            </div>
          </div>
        </div>
      </li>
    );
  };

  render() {
    const { t, purchases, currentPage, purchasesPerPage } = this.props;

    const indexOfLastPurchase = currentPage * purchasesPerPage;
    const indexOfFirstPurchase = indexOfLastPurchase - purchasesPerPage;
    const currentPurchases = purchases.slice(
      indexOfFirstPurchase,
      indexOfLastPurchase
    );

    return (
      <div className={styles.root}>
        <div className={styles.tableContainer}>
          <table>
            <thead>
              <tr>
                <th>{t('account.date')}</th>
                <th>{t('account.type')}</th>
                <th>{t('account.amount')}</th>
                <th>{t('account.status')}</th>
              </tr>
            </thead>
            <tbody>{currentPurchases.map(this.renderBillingHistoryRows)}</tbody>
          </table>
        </div>
        <ul className={styles.mobileList}>
          {currentPurchases.map(this.renderPurchasedItem)}
        </ul>
      </div>
    );
  }
}

export default translate(['account', 'paymentReceipt'])(
  AccountHistoricalPurchases
);



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountSubscriptions/components/AccountHistoricalPurchases/AccountHistoricalPurchases.jsx